import * as React from 'react';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';

export const selectSingleHierarchyCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods, fieldState: any) =>
  <SelectSingleHierarchy
    onChange={fieldMethods.handleChange(props.name)}
    componentId={props.name}
    className={props.className}
    label={fieldMethods.buildLabel(props.label)}
    validation={fieldMethods.getValidation(props.name)}
    valueItem={fieldMethods.getProperty(props.name) || []}
    options={fieldMethods.getOptions(props.name)}
    categoryOptions={fieldMethods.getCategoryOptions(props.name)}
    placeholder={props.placeholder}
    onLoadOptions={fieldMethods.onLoadOptions(props.name, props.optionsEndpoint, props.optionsParams)}
    loadOptions={fieldState.loadedOptions[props.name]}
    loadCategoryOptions={fieldState.loadedCategoryOptions[props.name]}
    isOpen={props.hasFocus}
    ref={fieldMethods.createRefToScrollableComponent(props.name)}
    fetching={fieldMethods.isFetching(props.name)}
    readOnly={props.readOnly}
    descriptionAllLevels={props.descriptionAllLevels}
    initiallyShowLongDescription={props.initiallyShowLongDescription}
    info={{ text: props.infoText, visible: !!props.infoText }}
    alwaysOpen={props.alwaysOpen}
    searchRequired={props.searchRequired}
    resetPreviousValueWhenEmpty={props.resetPreviousValueWhenEmpty}
    categoryId={props.categoryId}
    extraFooterButton={props.extraFooterButton}
    displayCategories={props.displayCategories}
    onLoadCategoryOptions={fieldMethods.onLoadCategoryOptions(props.name, props.categoryOptionsEndpoint, props.categoryOptionsParams)}
    meatballPanelConfiguration={props.meatballPanelConfiguration}
  />;
